import React from 'react';
import './Article.css';
import Img from 'gatsby-image';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { ButtonReturn } from '../../components/ButtonSquare';
import TechnologiesBlock from '../../components/TechnologiesBlock';

const Article = (props) => {
  const { data } = props;
  const article = data.datoCmsArticle;
  const {
    pictures, articleType, technologies, link, linkText,
  } = article;
  const theme = articleType === 'article' ? 'light' : 'dark';
  const picturesDivs = [];
  pictures.forEach((picture) => {
    picturesDivs.push(
      <Img key={picture.id} sizes={picture.sizes} alt={picture.alt} />,
    );
  });
  let technos = <div />;
  if (technologies && technologies.split(',').length > 1) {
    technos = <TechnologiesBlock technologies={technologies.split(',')} />;
  }
  return (
    <div className={`article_background_${theme} view_article`}>
      <Helmet
        title={`${article.title} - Com des Lézards`}
        // meta={[
        //   { name: 'description', content: 'Sample' },
        //   { name: 'keywords', content: 'sample, something' },
        // ]}
      />
      <div className="article_pictures_container">
        {picturesDivs}
      </div>
      <div className="article_description_container">
        <h2>
          {article.subtitle}
        </h2>
        <h1>
          {article.title}
        </h1>
        <p>
          <ReactMarkdown source={article.text} />
        </p>
        <div className="article_delimiter_container">
          <div className="delimiter" />
          <a href={link} rel="nofollow">
            {linkText}
          </a>
        </div>
        {technos}
      </div>
      <div className="article_return_button">
        <ButtonReturn theme={theme === 'dark' ? 'light' : 'dark'} />
      </div>
    </div>
  );
};

Article.defaultProps = {
  data: {},
};

Article.propTypes = {
  data: PropTypes.shape({
    datoCmsArticle: PropTypes.shape({
      id: PropTypes.number.isRequired,
      articleType: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      technologies: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      linkText: PropTypes.string.isRequired,
    }).isRequired,
  }),
};

export default Article;

export const query = graphql`
  query ArticleQuery($slug: String!) {
    datoCmsArticle(slug: {eq: $slug}) {
            id,
            articleType,
            title,
            subtitle,
            text,
            technologies,
            link,
            linkText,
            pictures {
              id,
              sizes(maxWidth: 600, imgixParams: { fm: "jpg", auto: "compress" }){
                ...GatsbyDatoCmsSizes
              },
              alt
            }
      }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/Article/Article.jsx